import { mapActions, mapMutations } from "vuex";
import { sendResetPasswordLink } from "../../../src/api/services/userService.js";
export default {
  methods: {
    ...mapActions([
      "signUserIn",
      "signUserInFacebook",
      "signUserInGoogle",
      "isGift",
    ]),
    ...mapMutations(["setStoreLoaded"]),
    forgetPassword() {
      this.loading = true;

      let that = this;
      sendResetPasswordLink(that.email, that.currentStoreDoc.ID)
        .then(function() {
          that.msg =
            "An email has been sent to your address, please follow the instructions on the email to reset your password.";
          that.loading = false;
        })
        .catch(function() {
          that.error = "Failed to send reset password email.";
          that.msg = "";
          that.loading = false;
        });
    },
    switchView(isLogin) {
      this.error = "";
      this.msg = "";
      this.isLogin = isLogin;
    },
    submit() {
      this.error = "";
      this.msg = "";
      if (this.isLogin) this.login();
      else this.forgetPassword();
    },
    login() {
      let that = this;
      this.$validator.validateAll().then(function(valid) {
        if (valid) {
          that.loading = true;
          that
            .signUserIn({ email: that.email, password: that.password })
            .then(() => {
              that.loading = false;
              if (
                that.currentStoreDoc &&
                that.currentStoreDoc.ViewComponentConfigs.LogIn &&
                that.currentStoreDoc.ViewComponentConfigs.LogInMandatory &&
                that.currentStoreDoc.ViewComponentConfigs.SMSVerification &&
                !that.dbuser.isVerified
              ) {
                that.showVerificationForm = true;
              } else {
                that.$emit("close-overlay");
                if (
                  that.isMobile() &&
                  that.$route.name === 'shoppingcartmobile' &&
                  that.currentStoreDoc.ID
                ) {
                  that.$router.push(`../../store/${that.currentStoreDoc.ID}/checkout`);
                }
              }
            })
            .catch((error) => {
              that.loading = false;
              that.error = error.message;
            });
        }
      });
    },
    facebookLogin() {
      let that = this;
      that.loading = true;
      this.signUserInFacebook()
        .then(() => {
          this.isSushi && this.$emit("overlay", false);
          // if (!that.isMobile())
          that.$emit("close-overlay");
          // else {
          //   if (!that.storeid) that.$router.push("/");
          //   else {
          //     if (that.forgift && that.forgift === true)
          //       that.$router.push(
          //         `../../store/${that.storeid}/checkout/giftcards`
          //       );
          //     else that.$router.push(`../../store/${that.storeid}/checkout`);
          //   }
          // }
          that.loading = false;
        })
        .catch((error) => {
          that.error = error.message;
          that.loading = false;
        });
    },
    googleLogin() {
      let that = this;
      that.loading = true;
      this.signUserInGoogle()
        .then(() => {
          this.isSushi && this.$emit("overlay", false);
          // if (!that.isMobile())
            that.$emit("close-overlay");
          // else {
          //   if (!that.storeid) that.$router.push("/");
          //   else {
          //     if (that.forgift && that.forgift === true)
          //       that.$router.push(
          //         `../../store/${that.storeid}/checkout/giftcards`
          //       );
          //     else that.$router.push(`../../store/${that.storeid}/checkout`);
          //   }
          // }
          that.loading = false;
        })
        .catch((error) => {
          that.error = error.message;
          that.loading = false;
        });
    },
  },
};
